var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({staticClass:"BaseImage observe-size",attrs:{"alt":_vm.properties.alt || '',"src":_vm.$isServer
      ? _vm.getPlaceholderSource(_vm.properties.src)
      : _vm.resizedSrc || _vm.getPlaceholderSource(_vm.properties.src),"data-src":_vm.properties.src || _vm.defaultImage,"data-tag":"BaseImage"}},'img',_vm.getWidthAndHeight(_vm.properties.src),false))}
var staticRenderFns = []

export { render, staticRenderFns }